// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "header[data-v-ddc8afa0]{z-index:1000}", ""]);
// Exports
module.exports = exports;
